<template>
  <div class="contens">
    <div class="con_content">
      <div>
        <h2>房产业务预审批</h2>
      </div>
      <table width="90%">
        <tr>
          <td width="20%">抵押顺序</td>
          <td width="40" colspan="3">{{ Dyorder }}</td>
          <td width="20%">典当额度 *</td>
          <td width="20%">
            
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Ddedquota' ? 'updateClassY':'updateClassN'"  v-model="Ddedquota" @focus="updateTextClass('Ddedquota')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ Ddedquota }}
            </span>
            </td>
        </tr>
        <tr>
          <td width="20%">当户 *</td>
          <td colspan="3">

             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Dhname' ? 'updateClassY':'updateClassN'"  v-model="Dhname" @focus="updateTextClass('Dhname')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ Dhname }}
            </span>
            </td>
          <td width="20%">电话 *</td>
          <td>
            
            <span v-if="state==0">
              <input :class="IsupdateTextClass== 'tel' ? 'updateClassY':'updateClassN'"  v-model="tel" @focus="updateTextClass('tel')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ tel }}
            </span>
            </td>
        </tr>
        <tr>
          <td width="20%">典当期限</td>
          <td colspan="3">{{ DdqxStartDate + "至" + DdqxEndDate}}</td>
          <td width="20%">分期还本</td>
          <td>{{ fqhbStaging }}</td>
        </tr>
        <tr>
          <td>担保日期 *</td>
          <td colspan="5">
            
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'DbDatevalue' ? 'updateClassY':'updateClassN'"  v-model="DbDatevalue" @focus="updateTextClass('DbDatevalue')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{DbDatevalue}}
            </span>
            </td>
        </tr>
        <tr>
          <td width="20%">月综合费率/% *</td>
          <td width="13.3%">
            
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'ZhfPrice' ? 'updateClassY':'updateClassN'"  v-model="ZhfPrice" @focus="updateTextClass('ZhfPrice')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ ZhfPrice }}
            </span>
            </td>
          <td width="13.3%">月利息费率/% *</td>
          <td width="13.3%">
           
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'lx' ? 'updateClassY':'updateClassN'"  v-model="lx" @focus="updateTextClass('lx')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ lx }}
            </span>
            </td>
          <td>每月还本 *</td>
          <td>
          
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Hbalso' ? 'updateClassY':'updateClassN'"  v-model="Hbalso" @focus="updateTextClass('Hbalso')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
           {{ Hbalso }}
            </span>
            </td>
        </tr>
        <tr>
          <td>房产地址 *</td>
          <td colspan="4">
         
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Fcaddres' ? 'updateClassY':'updateClassN'"  v-model="Fcaddres" @focus="updateTextClass('Fcaddres')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
            {{ Fcaddres }}
            </span>
            </td>
          <td>需要特批事项 *</td>
        </tr>
        <tr>
          <td>他项权证</td>
          <td colspan="2">
            <span v-if="TxqzWarrant!==''">
             <span class="clickView" @click="ViewClick(TxqzWarrant)">点击查看</span>
            </span>
            <span v-else-if="state == 0" class="clickView">
              
                 <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'TxqzWarrant'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>
          </td>
          <td>抵押方式</td>
          <td>{{ DyfsGuaranty }}</td>
          <td rowspan="4">
            
            <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Special' ? 'updateClassY':'updateClassN'"  v-model="Special" @focus="updateTextClass('Special')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
            {{ Special }}
            </span>
            </td>
        </tr>
        <tr>
          <td rowspan="4">转账支付（指示支付</td>
          <td>户名 *</td>
          <td colspan="3">
        
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'HmName' ? 'updateClassY':'updateClassN'"  v-model="HmName" @focus="updateTextClass('HmName')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
             {{ HmName }}
            </span>
            </td>
        </tr>
        <tr>
          <td>开户行 *</td>
          <td colspan="3">
            
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'KhBank' ? 'updateClassY':'updateClassN'"  v-model="KhBank" @focus="updateTextClass('KhBank')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
              {{ KhBank }}
            </span>
            </td>
        </tr>
        <tr>
          <td>账号 *</td>
          <td colspan="3">
            
            <span v-if="state==0">
              <input :class="IsupdateTextClass== 'Account' ? 'updateClassY':'updateClassN'"  v-model="Account" @focus="updateTextClass('Account')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
              {{ Account }}
            </span>
            </td>
        </tr>
        <tr>
          <td>其他方式 *</td>
          <td colspan="3">
            
              <span v-if="state==0">
              <input :class="IsupdateTextClass== 'other' ? 'updateClassY':'updateClassN'"  v-model="other" @focus="updateTextClass('other')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
              {{ other }}
            </span>
            </td>
          <td></td>
        </tr>
        <tr>
          <td>一抵情况 *</td>
          <td colspan="5">
           
             <span v-if="state==0">
              <input :class="IsupdateTextClass== 'OneMortgage' ? 'updateClassY':'updateClassN'"  v-model="OneMortgage" @focus="updateTextClass('OneMortgage')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
               {{ OneMortgage }}
            </span>

            </td>
        </tr>
        <tr>
          <td>二抵情况 *</td>
          <td colspan="5">
            <span v-if="state==0">
              <input :class="IsupdateTextClass== 'TwoMortgage' ? 'updateClassY':'updateClassN'" v-model="TwoMortgage" @focus="updateTextClass('TwoMortgage')" @blur="updateTextClassA"/>
            </span>
            <span v-else>
              {{ TwoMortgage }}
            </span>
            
          </td>
        </tr>
        <tr>
          <td>收集受理资料</td>
          <td colspan="4">
           
            <span v-if="Material!==''">
             <span class="clickView" @click="ViewClick(Material)">点击查看</span>
            </span>
            <span v-else-if="state == 0" class="clickView">
              <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'Material'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>

          </td>
          <td>（由经办人收齐确认）</td>
        </tr>
        <tr>
          <td>合同合规审核</td>
          <td colspan="4">
            <!-- {{ ContractReview }} -->
           <span v-if="ContractReview!==''">
             <span class="clickView" @click="ViewClick(ContractReview)">点击查看</span>
            </span>
            <span v-else-if="state == 0" class="clickView">
               <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'ContractReview'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>

          </td>
          <td>（由法务确认）</td>
        </tr>
        <tr>
          <td>合同签订</td>
          <td colspan="4">
            <!-- {{ ContractSigning }} -->

             <span v-if="ContractSigning.length !==0 ">
                <span class="clickView" @click="ViewClick(ContractSigning)">点击查看</span>
            </span>
            <span v-else-if="state == 0" class="clickView">
              <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'ContractSigning'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>

          </td>
          <td>（由总经理负责面签，是否发放当金最终以签订当票为准）</td>
        </tr>
        <tr>
          <td>实地调查</td>
          <td colspan="4">
            <!-- {{ FieldTrips }} -->
             <span v-if="FieldTrips!==''">
                <span class="clickView" @click="ViewClick(FieldTrips)">点击查看</span>
            </span>
           <span v-else-if="state == 0" class="clickView">
              <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'FieldTrips'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>

            </td>
          <td>（房屋与房产证记载是否一致，房屋现状及使用是否异常）</td>
        </tr>
        <tr>
          <td>抵押入押</td>
          <td colspan="4">

            <!-- {{ Confirm }} -->
             <span v-if="Confirm !== ''">
                <span class="clickView" @click="ViewClick(Confirm)">点击查看</span>
            </span>
            <span v-else-if="state == 0" class="clickView">
              <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="uploads"
                            :data="{isName:'Confirm'}"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="1"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            上传
                  </el-upload>
            </span>
            <span v-else class="noReview">
              *未上传材料，请返回补充材料*
            </span>
            
            </td>
          <td>（不动产登记证明内容与房屋抵押后查档记载的信息是否一致）</td>
        </tr>
        <tr>
          <td colspan="6"><h2>完成以上业务流程呈总经理审批发放当金</h2></td>
        </tr>
        <tr>
          <td>财务室</td>
          <td colspan="4">
            <!-- {{ Finance }} -->
             <span class="clickView" v-if="state == 0">发起确认签名</span>
            <span v-else >{{Finance}}</span>
            </td>
          <td>（注意管理办法对当金放款的限制和费率的规定）</td>
        </tr>
        <tr>
          <td>总经理审批放款</td>
          <td colspan="5">
            <!-- {{ Ratify }} -->
             <span class="clickView" v-if="state == 0">发起确认签名</span>
            <span v-else class="noReview">{{Ratify}}</span>
            </td>
        </tr>
        <tr>
          <td>开票出纳</td>
          <td colspan="4">
            <!-- {{ Cashier }} -->
            <span class="clickView" v-if="state == 0">发起确认签名</span>
            <span v-else class="noReview">{{Cashier}}</span>
            
            </td>
          <td>（总经理签名批款后，才能出当票、支付当金）</td>
        </tr>
      </table>

      <!-- 按钮 -->
      <div class="btn">
        <el-button type="primary" v-if="state == 0" @click="Upload">上传补充凭证</el-button>
        <el-button type="primary" v-if="state == 1" @click="Submit">复核通过</el-button>
        <el-button type="primary" v-if="state == 0"  @click="test('a')">修改</el-button>
      </div>
      <div style="color:red">
        带*号的为可修改项目,仅在业务还未被复核 补充资料时可修改
      </div>
    </div>

    

    <!-- 弹窗 -->
    <div class="dialog">
      <el-dialog
        title="详情"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
       
       <div  class="details">
         <iframe :src="detail" frameborder="0" width="100%" height="100%"></iframe>
       </div>
       
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">关 闭</el-button>
          <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
const COS = require("cos-js-sdk-v5");
const cos = new COS({
  SecretId: "AKID1pOghRu62i7G8j36sOddMoztXv2tUord", // 身份识别ID
  SecretKey: "YjdHfndCUVGjwta091cwzmIXVBbkcEag", // 身份秘钥
});

export default {
  name: "HouseDetails",
  data() {
    return {
      reviewData: {},
      state: "",

      //数据
      Dyorder: "", //典当顺序
      Ddedquota: "", //典当额度
      Dhname: "", //当户名字
      tel: "", //电话
      DdqxStartDate: "", //典当开始日期
      DdqxEndDate:"", //典当到期日期
      fqhbStaging: "", //分期还本
      ZhfPrice: "", //综合费
      lx: "", //利息
      Hbalso: "", //还本
      Fcaddres: "", //房产地址
      TxqzWarrant: "", //他项权证
      DyfsGuaranty: "", //抵押方式
      Special: "", //特批事项
      HmName: "", //户名
      KhBank: "", //开户行
      Account: "", //账号
      other: "", //其他
      OneMortgage: "", //一抵情况
      TwoMortgage: "", //二抵情况
      Material: "", //收集受理资料

      ContractReview: "", //合同审核
      ContractSigning: "", //合同签订
      FieldTrips: "", //调查资料
      Confirm: "", //抵押确认

      Finance: "", //财务
      Ratify: "", //经理批准
      Cashier: "", //出纳

      CreateDate: "", //创建日期
      CreateUser: "", //经办人
      review: "", //复核人
      id:"", //id

      DbDatevalue:"", //担保日期

      userData:{
          username:""
      },
      TodayDate:"", //今天的日期

      dialogVisible:false, //弹窗开关，默认关闭
      detail:[],

      fileList:[],

      IsupdateTextClass:'', //默认不修改修改文字，文字为黑色

    };
  },
  methods: {
    

    setDatas() {
      let data = JSON.parse(this.$Base64.decode(this.$route.query.str));



      // console.log(typeof(data.ContractSigning)),

      // this.reviewData = JSON.parse(this.$Base64.decode(this.$route.query.str))
      // this.state = JSON.parse(this.$route.query.state);

      (this.Dhname = data.Dhname),
        (this.Dyorder = data.Dyorder),
        (this.Ddedquota = data.Ddedquota),
        (this.tel = data.tel),
        (this.DdqxStartDate = data.DdqxStartDate),
        (this.DdqxEndDate = data.DdqxEndDate),
        (this.fqhbStaging = data.fqhbStaging),
        (this.ZhfPrice = data.ZhfPrice),
        (this.DbDatevalue = data.DbDatevalue),
        (this.lx = data.lx),
        (this.Hbalso = data.Hbalso),
        (this.Fcaddres = data.Fcaddres),
        (this.TxqzWarrant = data.TxqzWarrant),
        (this.DyfsGuaranty = data.DyfsGuaranty),
        (this.Special = data.Special),
        (this.HmName = data.HmName),
        (this.KhBank = data.KhBank),
        (this.Account = data.Account),
        (this.other = data.other),
        (this.OneMortgage = data.OneMortgage),
        (this.TwoMortgage = data.TwoMortgage),
        (this.Material = data.Material),
        (this.ContractReview = data.ContractReview),
        (this.ContractSigning = data.ContractSigning),
        (this.FieldTrips = data.FieldTrips),
        (this.Confirm = data.Confirm),
        (this.Finance = data.Finance),
        (this.Ratify = data.Ratify),
        (this.Cashier = data.Cashier),
        (this.CreateDate = data.CreateDate),
        (this.CreateUser = data.CreateUser),
        (this.review = data.review),
        this.id = data._id

      // console.log(JSON.parse(this.$Base64.decode(this.$route.query.str)))
      // console.log(JSON.parse(this.$route.query.state))
      // console.log('666',data.Dhname)
    },

  
    //点击补充资料
    Upload() {

      console.log(this.TxqzWarrant)
   
      this.axios.post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("house").doc("${this.id}").update({
                        data:{
                             Review: "${this.userData.username}",
                            Material:"${this.Material}",
                            ContractReview:"${this.ContractReview}",
                            ContractSigning:"${this.ContractSigning}",
                            FieldTrips:"${this.FieldTrips}",
                            Confirm:"${this.Confirm}"

                        }
                    })`
                    }).then(res=>{
                        if(res.data.errcode == 0){
                             this.$message({
                                type: "success",
                                message: "补充凭证上传成功",
                            });
                            setTimeout(()=>{
                              this.$router.go(0)
                            },1000)
                            
                        }
                      
                    })

    },
    //点击复核
    Submit() {
      this.$confirm("确定复核通过该业务吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
            //添加复核人
            this.UpDatas()
            
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消复核",
          });
        });
    },
    //提交复核
    UpDatas(){
          this.axios.post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("house").doc("${this.id}").update({
                        data:{
                            Review: "${this.userData.username}",
                            ReviewDate:"${this.TodayDate}"
                        }
                    })`
                    }).then(res=>{
                        if(res.data.errcode == 0){
                             this.$message({
                                type: "success",
                                message: "复核成功!",
                            });
                            this.$router.push("/reviewHouse")
                        }
                      
                    })
    },
    //点击查看详情
    ViewClick(event){
      console.log(event)
      this.dialogVisible = !this.dialogVisible
      this.detail = event
      
    },
    //关闭查看详情
    handleClose(){
      this.dialogVisible = false
      this.detail = []
    },

    //        //element 上传方法
    uploads(res) {
      console.log(this[res.data.isName])
      console.log(res.data.isName)


      if (res.file) {

        // 执行上传操作
        cos.putObject(
          {
            Bucket: "changan-1259114000" /* 存储桶 */,
            Region: "ap-guangzhou" /* 存储桶所在地域，必须字段 */,
            Key: res.file.name /* 文件名 */,
            StorageClass: "STANDARD", // 上传模式, 标准模式
            Body: res.file, // 上传文件对象
          },
          (err, data) => {
console.log(err,data)
                 
            // 上传成功之后
            if (data.statusCode == 200) {
              this[res.data.isName] = "https://" + data.Location;

              console.log("https://" + data.Location)

           
            }
          }
        );
      }
    },
    handlePreview(file){
        console.log(file)
    }, 
    //删除上传图片
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      //确定删除上传的图片
       beforeRemove(file) {

           this.$confirm(`确定移除 ${ file.name }？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           cos
        .deleteObject({
          Bucket: "changan-1259114000" /* 填入您自己的存储桶，必须字段 */,
          Region: "ap-guangzhou" /* 存储桶所在地域，例如ap-beijing，必须字段 */,
          Key: file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "文件删除成功",
            type: "success",
          });
        });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

      },
      //限制上传的文件数量
       handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },

      //点击修改时文字的颜色
      updateTextClass(event){
        this.IsupdateTextClass = event
      },
      //文字修改失去焦点的时候文字的时候
      updateTextClassA(){
        this.IsupdateTextClass = ''
      }





  },
  created() {
           //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
    //获取到复核日期
    this.TodayDate = dayjs().format('YYYY-MM-DD')

    this.state = JSON.parse(this.$route.query.state);
  },
  mounted() {
    //拿到数据
    setTimeout(()=>{
      this.setDatas();
    },800)
    
   
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
td {
  height: 50px;
  border: 1.5px solid black;
  font-size: 15px;
  text-align: center;
  font-weight: bold;
}
.con_content {
  width: 100%;
  height: 100%;
  padding: 20px 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btn {
  margin: 20px auto;
}
.clickView{
  color: #7d36da;
  text-decoration:underline
}
.noReview{
  color: red;
}
.details{
  height:65vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.updateClassN{
  width: 95%;
   border: 0;
   outline: none;
   font-weight: bold;
   font-size: 15px;
   color: #444444;;
    text-align: center;
}
.updateClassY{
  width: 95%;
   border: 0;
   outline: none;
   font-weight: bold;
   font-size: 20px;
   color: #dd2424;
    text-align: center;
}
</style>
